var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dd463;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grass_3",
    "data-name": "grass 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.4,789.4S734.58,576,1294.14,576c0,0-66.43-233.88-231.63-98.9-13.48-71.63-68-127.42-135.34-139.89-79.64-14.74-163.1,33.66-192.59,116.46-30.77-88.14-112.1-141-184.13-131.9-92,11.55-171.64,124.38-136,246.42C346,547.84,279.55,572.87,258.3,615,231.84,667.52,268.13,761.12,362.4,789.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects29);
export default __webpack_public_path__ + "static/media/objects-29.a549a4068a8223ec2d064219f95bec0a.svg";
export { ForwardRef as ReactComponent };